import { render, staticRenderFns } from "./UserChooser.vue?vue&type=template&id=1dfd53ac"
import script from "./UserChooser.vue?vue&type=script&lang=js"
export * from "./UserChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports